var chunkMapping = {
	"197": [
		60197
	],
	"900": [
		20900
	],
	"1366": [
		71366
	],
	"2009": [
		32009
	],
	"3797": [
		83797
	],
	"3816": [
		8497,
		72118
	],
	"4631": [
		64631
	],
	"7261": [
		27261
	],
	"8873": [
		28873
	],
	"9041": [
		69041
	]
};
var idToExternalAndNameMapping = {
	"8497": [
		"default",
		"./sagas",
		71638
	],
	"20900": [
		"default",
		"./Routes",
		71638
	],
	"27261": [
		"default",
		"./Routes",
		94200
	],
	"28873": [
		"default",
		"./Routes",
		8416
	],
	"32009": [
		"default",
		"./Routes",
		69208
	],
	"60197": [
		"default",
		"./Routes",
		73120
	],
	"64631": [
		"default",
		"./Routes",
		50812
	],
	"69041": [
		"default",
		"./Routes",
		81356
	],
	"71366": [
		"default",
		"./Routes",
		86746
	],
	"72118": [
		"default",
		"./reducer",
		71638
	],
	"83797": [
		"default",
		"./Routes",
		50474
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}